<template>
  <div class="fixed-plugin" :class="showSettingsDrawer == true ? 'show' : ''">
    <v-card class="shadow-lg">
      <div v-if="showForm">
        <edit-location :hide-form="hideForm"></edit-location>
      </div>
      <div v-if="!showForm">
        <div class="card-padding mb-16">
          <div class="float-start">
            <h5 class="text-h5 text-typo font-weight-bold mt-3 mb-0">
              {{ location.name }}
            </h5>
          </div>
          <div class="float-end mt-4">
            <v-btn
              :ripple="false"
              icon
              rounded
              width="20px"
              height="20px"
              class="text-dark"
              @click="$emit('toggleSettingsDrawer', false)"
            >
              <v-icon size="12">fa fa-times</v-icon>
            </v-btn>
          </div>
        </div>
        <hr class="horizontal black my-1" />
        <div class="card-padding">
          <div>
            <h5 class="text-h6 text-typo font-weight-bold mb-2">Contact</h5>
            <h6 class="font-weight-light">
              {{ location.locationContact }}
            </h6>
            <h6>{{ formattedPhoneNumber }}</h6>
          </div>
          <hr class="horizontal black my-1 mt-3 mb-5" />

          <div class="mt-5">
            <h5 class="text-h6 text-typo font-weight-bold mb-2">Address</h5>
            <h6 class="font-weight-light">{{ fullAddress }}</h6>
          </div>
          <hr class="horizontal black my-1 mt-3 mb-5" />
          <location-list v-if="!showForm" :items="locations"></location-list>
          <v-btn
            outlined
            class="mt-5 pr-3 pl-3"
            width="50%"
            block
            @click="showForm = !showForm"
            >Edit Location</v-btn
          >
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Vue from "vue";
import VueGitHubButtons from "vue-github-buttons";
import "vue-github-buttons/dist/vue-github-buttons.css";

Vue.use(VueGitHubButtons);
import LocationList from "../../views/Components/LocationList.vue";
import EditLocation from "../../components/EditLocation.vue";
export default {
  components: {
    EditLocation,
    LocationList,
  },
  props: {
    showSettingsDrawer: {
      type: Boolean,
      default: false,
    },
    sidebarColor: {
      type: String,
      default: "success",
    },
    sidebarTheme: {
      type: String,
      default: "transparent",
    },
    navbarFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      benched: 0,
      list: null,
      showForm: false,
      key: 0,
      sidebarColorModel: this.sidebarColor,
      isActive: false,
      navbarFixedModel: this.navbarFixed,
    };
  },
  computed: {
    fullAddress() {
      return `${this.location.address1}, ${this.location.city}, ${this.location.state} ${this.location.zip}, USA`;
    },
    location() {
      return this.$store.state.location;
    },
    locations() {
      return this.$store.state.locations;
    },
    formattedPhoneNumber() {
      return this.location.phoneNumber.replace(
        /(\d{3})(\d{3})(\d{4})/,
        "($1) $2-$3"
      );
    },
  },
  methods: {
    hideForm() {
      this.key++;
      this.showForm = false;
      this.setData();
    },
    logout() {
      this.$store.dispatch("logoutUser");
    },
    active: function () {
      this.isActive = !this.isActive;
    },
    setData() {
      this.list = this.$store.state.locations;
    },
  },
  created() {
    this.setData();
  },
};
</script>
<style scoped>
.scrollable-div {
  height: 375px; /* Set the height you need */
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: hidden; /* Disable horizontal scrolling */
  font-weight: 10px !important;
}
</style>